{
  "titles": {
    "menu": "Accounts",
    "table": "Accounts",
    "create": "Account aanmaken",
    "update": "Account wijzigen",
    "account": "Account",
    "accountInformation": "Account informatie",
    "settings": "Bevoegdheden"
  },
  "fields": {
    "labels": {
      "Key": "Account nummer",
      "gender": "Geslacht",
      "initials": "Initialen",
      "firstNames": "Voornamen",
      "lastName": "Achternaam",
      "name": "Volledige naam",
      "email": "E-mailadres",
      "phone": "Telefoonnummer",
      "role": "Rol",
      "dateOfBirth": "Geboortedatum",
      "placeOfBirth": "Geboorteplaats",
      "address": "Adres",
      "isSigningAuthority": "Is tekenbevoegd",
      "isRepresentative": "Is vertegenwoordiger",
      "isIdentityValidated": "Identiteit spaarder controle",
      "identityValidationMethod": "Identificatie methode digitaal verzenden",
      "true-isIdentityValidated": "Identiteit spaarder is gecontroleerd",
      "true-isBusinessInformationValidated": "KvK uittreksel & statuten zijn gecontroleerd",
      "hasAccessToFunderPortal": "Heeft toegang tot de app"
    },
    "descriptions": {
      "isSigningAuthority": "Ondertekent het spaarcontract",
      "isRepresentative": "Vertegenwoordigt de spaarder en ontvangt de berichten",
      "hasAccessToFunderPortal": "Inloggen bij het spaarders portaal"
    },
    "hints": {

    },
    "validationErrors": {
      "isSigningAuthority": {
        "equals": "De vertegenwoordiger moet tekenbevoegd zijn"
      },
      "funder": {
        "dateOfBirth": {
          "maxDate": "{0} mag niet in de toekomst liggen"
        }
      }
    }
  },
  "headers": {
    "labels": {
      "isSigningAuthority": "Tekenbevoegd",
      "isIdentityValidated": "Identificatie"
    }
  },
  "messages": {
    "createSuccess": "Account aangemaakt",
    "updateSuccess": "Account is opgeslagen",
    "checkedAtBy": "Gecontroleerd op {date} door {name}",
    "tableItemIsRepresentative": "Vertegenwoordiger"
  },
  "actions": {
    "create": "Account aanmaken",
    "update": "Account aanpassen",
    "search": "Zoek een account",
    "impersonate": "Inloggen als"
  }
}
